import { NonMemoizedOptimizedImage } from '../components/OptimizedImage/OptimizedImage';
import Link from '../components/Link/Link';
import TableOfContents from '../components/TableOfContents/TableOfContents';
import SeriesOfArticles, {
  DescriptionSeriesOfArticles,
  TitleSeriesOfArticles,
} from '../components/SeriesOfArticles/SeriesOfArticles';
import AbilityFromViewModel from '../components/AbilityFromViewModel/AbilityFromViewModel';

const enhancedMarkdownOverrides = {
  Image: NonMemoizedOptimizedImage,
  img: NonMemoizedOptimizedImage,
  a: Link,
  TableOfContents: TableOfContents,
  SeriesOfArticles: SeriesOfArticles,
  Title_SeriesOfArticles: TitleSeriesOfArticles,
  Description_SeriesOfArticles: DescriptionSeriesOfArticles,
  Ability: AbilityFromViewModel,
};
export default enhancedMarkdownOverrides;
